export default "__VITE_ASSET__DMcNc9lj__"